<gg-button size="md" color="primary" styleType="raised-button" (clickEvent)="book.emit()" *ngIf="!isNonBookable">
  {{ label }}
</gg-button>

<gg-button size="md" color="primary" styleType="raised-button" (clickEvent)="contactUs()" *ngIf="isNonBookable">
  Contact Us
</gg-button>
